<template>
<div                  
    :class="{
              dragover: taskTemplateGroupItemsDragover,
              showselecttext: task_group_id!='' || dragDropFlagTaskTemplageGroup,
            }" 
    @drop="onTaskTemplateGroupItemsDrop" 
    @dragenter.prevent ="onTaskTemplateGroupItemsDragover"
    @dragover.prevent ="onTaskTemplateGroupItemsDragleave"
    class="cmp-settings-task-template-groups-item"
  >
  <!-- <LoadingUI
    v-if="settingsData && settingsData[`${this.externalTable}_task_templates_of_group_loading`]"
  /> -->
   <!-- v-else -->
    <div  
      v-if="list.length<1"
       class="select-text"
    >
      {{!dragDropFlagTaskTemplageGroup? "Select a Task Group to view Task Group Items.": "Drag and Drop a Task Template to add to the Task Group"}}
    </div>
    <!-- <LoadingUI /> -->
    <DList
      :items="list"
      :primaryKey="'task_template_id'"
      :labelKey="'task_template_name'"
      @delete="onTaskTemplateGroupItemDelete"
    />
</div>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import { createNTableConfig } from "@/plugins/datatable";
import { openModalRoute } from "@/dt-plugins/modal/modal.mixin";
import { createTableHeader } from "@/plugins/datatable";
import { mapKeyToAction } from "../../../../store/global";
import { SettingsStoreNamespace as storeNS} from "../../store";
import DList from "@dtplugins/list/dlist";
import * as ActionTypes from "../../store/types";
import eventBus from './bus'
import { JSONX } from "../../../../utility";
import { NotificationService } from "../../../../dt-plugins/notification/notification.service";
import { BookingSettingsService } from "../../services/booking-settings.service";
export default {
  mounted() {
   
    eventBus.$on('selectItemGroup', (payload) => {
      console.log('selectItemGroup',payload)

      this.task_group_id = payload.task_group_id;
      this.settingsKey = payload.settingsKey;

    })
  },
  beforeDestroy() {
   
    eventBus.$off('selectItemGroup')
  },
  components: {
    NTable,
    DBox,
    DList
  },
  props: {
    settingsData: {
      type: Object,
      default: () => {}
    },
    externalTable: {
      type: String,
      default: () => ''
    },

  },
  data: function() {
    return {
       task_group_id:'',
       settingsKey:'',
       taskTemplateGroupItemsDragover: false,

    };
  },
  computed: {

    list: function() {
      return this.settingsData?.[`${this.externalTable}_task_templates_of_group`] || [];
    },
    dragDropFlagTaskTemplageGroup: function () {

        if (this.settingsData[`${this.externalTable}_task_templates_of_group`]) {
          if (this.settingsData[`${this.externalTable}_task_templates_of_group`].length > 0) {
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }

    },
  },
  methods: {
    ...mapKeyToAction(storeNS, [
      ActionTypes.TaskTemplateGroupItems.DELETE.SINGLE,
      ActionTypes.TaskTemplateGroupItems.SET.ALL
    ]),
    onAddTaskTemplateClick: function() {
      //this.$emit("add_click", true);
      openModalRoute(this, "task_template_form", {
        mode: "add",
        external_table:this.externalTable
      });
    },
    onDeleteTaskTemplate: function({ task_template_id }) {
      this.$emit("delete", task_template_id);
    },
    onEditTaskTemplate: function({ task_template_id }) {
      openModalRoute(this, "task_template_form", {
        task_template_id,
        mode: "edit",
        external_table:this.externalTable
      });
    },
    // onTaskTemplateDragStart: function(event, item) {
    //   if (!item) {
    //     return;
    //   }
    //   event.dataTransfer.setData("text", JSON.stringify(item));
    // },
    onTaskTemplateGroupItemsDragover: function (event) {
      event.preventDefault();
      console.log("dragover");
      this.taskTemplateGroupItemsDragover = true;
    },
    onTaskTemplateGroupItemsDragleave: function () {
      this.taskTemplateGroupItemsDragover = false;
    },
    onTaskTemplateGroupItemsDrop:async function(event){
      event.preventDefault();

      this.taskTemplateGroupItemsDragover = false;

      if(this.task_group_id!=''){
        const parseResult = JSONX.tryParse(event.dataTransfer.getData("text"));

        const { task_template_id } =parseResult.result;

        const res = await BookingSettingsService.addTaskToTaskTemplateGroup({task_template_id:task_template_id,task_group_id:this.task_group_id})

        this[ActionTypes.TaskTemplateGroupItems.SET.ALL]({settingsKey:this.settingsKey,external_table:this.externalTable,task_group_id:this.task_group_id})


        console.log(parseResult,"DROP");
      }else{
        NotificationService.showNotification({
          text: "Please Select a Valid Task Group before dropping an Task Template Item",
          timeout: 5000,
          type: "error",
        });
      }
      
    },
    onTaskTemplateGroupItemDelete: function (item) {
      // console.log('mdsir', item);
      const table = this.externalTable;
      const settingsKey ='taskSettingsData'; //table=='booking'?'bookingSettingsData':'labelSettingsData';
      this[ActionTypes.TaskTemplateGroupItems.DELETE.SINGLE]({
        task_group_id: this.task_group_id,
        task_template_id: item.task_template_id,
        settingsKey:settingsKey,
        external_table:this.externalTable
      });
    },
    // MARK: Methods
  }
};
</script>

<style lang="scss">
.cmp-settings-task-template-groups-item {
  .dt-ntable {
    td.options {
      display: flex;
      flex-direction: row;
    }
  }
  //.task-items-container {
    width: 100%;
    height: 100%;
    .select-text {
      display: none;
    }
    &.dragover {
      background: rgba(128, 128, 128, 0.192);
    }
    &.showselecttext {
      .select-text {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100%;

        color: var(--text-secondary);
        font-size: 22px;
        font-weight: 600;
        text-align: center;
      }
    }
  //}
}
</style>
